import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import HeaderEpics from './Header/epics'
import { fetchIncidentError, fetchIncidentSuccess } from './actions'
import { FILTER_CHANGE, INCIDENT_REQUEST_ASYNC, PAGINATE_CHANGE } from './constants'

const fetchIncidentEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(INCIDENT_REQUEST_ASYNC.INITIATE, PAGINATE_CHANGE, FILTER_CHANGE),
    mergeMap((action) => {
      const incidentId =
        action.payload?.incidentId || state$.value.resolutioncenter.atoIncident.incidentId

      return api.resolutionCenter
        .getAtoIncident(incidentId, state$.value.resolutioncenter.atoIncident.page, {
          ...state$.value.resolutioncenter.atoIncident.allFilters,
          locationFilter:
            state$.value.resolutioncenter.atoIncident.allFilters?.locationFilter.length > 0
              ? state$.value.resolutioncenter.atoIncident.allFilters?.locationFilter
                  ?.map((e) => encodeURIComponent(e))
                  .join('~')
              : '',
        })
        .pipe(
          map((response) => fetchIncidentSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchIncidentError, error))),
          takeUntil(action$.pipe(ofType(INCIDENT_REQUEST_ASYNC.CANCEL)))
        )
    })
  )

export default combineEpics(fetchIncidentEpic, HeaderEpics)
